/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react';
import * as THREE from "three";

import { const_var, params } from '../../../../../redux/reducers/reducer';
import { extrudeSettings, railModel } from '../../../../../utils/Functions';
import PillarRailModel from '../../Legs';
import BaseRailModel from '../../BaseRail';
import CommonTruss from '../CommonTruss';
import { MaterialTruss } from '../../../CustomMaterial';

const connectRailWidth = 0.3;
const connectRailHeight = 0.2;

const Standard = ({ trussType, normalMap, envMap , trussModelPosInfoArr, overlapTrussArr, hiddenBaseRailIdArr, meshDelModel_CSG, isFor }) => {
    return (
        <>
            {isFor === 'center' && <BaseRailModel normalMap={normalMap} envMap={envMap} meshDelModel_CSG={meshDelModel_CSG} />}
            {isFor === 'center' && <PillarRailModel trussType={trussType} trussModelPosInfoArr={trussModelPosInfoArr} normalMap={normalMap} envMap={envMap} meshDelModel_CSG={meshDelModel_CSG} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr} />}
            <TrussModel trussType={trussType} trussModelPosInfoArr={trussModelPosInfoArr} normalMap={normalMap} envMap={envMap} meshDelModel_CSG={meshDelModel_CSG} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr} isFor={isFor} />
        </>
    )
}

export default Standard

const TrussModel = ({ trussType, trussModelPosInfoArr, overlapTrussArr, hiddenBaseRailIdArr, normalMap, envMap, isFor }) => {
    const obj_rungHRail = new THREE.Object3D();

    const [rungHRail, setRungHRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));

    const offset = params.p_b_t === 27 ? 0.04 : 0.035;
    const rungHRailLength = (trussType === "RBOAT") ? 6 : (trussType === "RBOBT") ? 8 : 3

    const alignPosOffset = useMemo(() => {
        if(params.p_r_s === 1 ) return const_var.roofRegularDst * 2;
        else if(params.p_r_s === 2 || params.p_r_s === 3) return 0;
        else return 0;
    }, [params.p_r_s, params.p_r_p])
    
    useMemo(() => {
            const instancedRungHRail = [];

            new Array(trussModelPosInfoArr.length).fill('').forEach((_, index_truss) => {
                let rungTrussPosY = params.p_h - connectRailWidth / 2 + params.p_w / 2 * params.p_r_p / 12 - rungHRailLength / 2 * params.p_r_p / 12;
                if(trussType === "RBOAT" || trussType === "RBOBT") rungTrussPosY = params.p_h + (( params.p_w / 2 ) * params.p_r_p / 12) - (rungHRailLength/2 * (params.p_r_p / 12)) - connectRailHeight/2;
                //----- rung truss-----
                //----- rung truss-----
                obj_rungHRail.position.set(-rungHRailLength / 2, rungTrussPosY + alignPosOffset, trussModelPosInfoArr[index_truss]);
                obj_rungHRail.rotation.y = Math.PI / 2;

                if (hiddenBaseRailIdArr.includes(index_truss)) obj_rungHRail.scale.setScalar(0);
                else obj_rungHRail.scale.setScalar(1);

                obj_rungHRail.updateMatrix();
                instancedRungHRail.push(...obj_rungHRail.matrix.elements);
                //---------------------
            })

            setRungHRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedRungHRail), 16));
        
    }, [trussModelPosInfoArr, trussType, params.p_h, params.p_w, params.p_r_p, params.p_r_s])

    return (
        <group position={[0, -offset, 0]} name='garage-truss-legs'>
             <CommonTruss trussType={trussType} trussModelPosInfoArr={trussModelPosInfoArr} overlapTrussArr={overlapTrussArr} normalMap={normalMap} envMap={envMap} isFor={isFor} />

            {
                !(params.singleSlope && (params.freeStandingSide === "left" || params.freeStandingSide === "right")) &&
                rungHRail.array.length && [1].map((item) =>
                <instancedMesh key={rungHRail.array.length} instanceMatrix={rungHRail} instanceMatrix-needsUpdate={true} args={[null, null, trussModelPosInfoArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(connectRailWidth, connectRailHeight), extrudeSettings(rungHRailLength)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>)
            }
        </group>
    )
}